import {useAuthUser} from "@/features/identity/hooks/useAuthUser.ts";
import {Roles} from "@/@types/auth.types.ts";

// A user may hold several roles (one known app role plus additional roles, e.g. "test_role").
// Resolve to a single role that drives the UI: SuperAdmin first, then the highest known role for
// the currently selected tenant (Admin before Owner). Unknown/additional roles are ignored so we
// never return a value the UI can't render.
export const useUserRole = (): Roles | undefined => {
    const {user, tenant} = useAuthUser();

    if (user?.roles?.some(role => role.role === Roles.superAdmin)) return Roles.superAdmin;

    const tenantRoles = user?.roles?.filter(role => role.tenantId === tenant?.id) ?? [];

    if (tenantRoles.some(role => role.role === Roles.admin)) return Roles.admin;
    if (tenantRoles.some(role => role.role === Roles.owner)) return Roles.owner;

    return undefined;
}
